import styles from '../../pages/Account/styles.module.css';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Preset } from '../Preset';
import { PresetInterface } from '../Preset/Preset';
import { GraphTypes } from '../../types/general';
import StorageContent from '../../pages/Storage/Storage/components/StorageContent';
import { Button } from '../Button';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';
import { useSearchParams } from 'react-router-dom';

const OverviewCategoryItems = ({
    type,
    presets,
    handleDeletePopup,
    setShowDownload,
}: {
    type: GraphTypes;
    presets: PresetInterface[];
    handleDeletePopup: any;
    setShowDownload: any;
}) => {
    const [searchParams] = useSearchParams();

    const [items, setItems] = useState<PresetInterface[]>([]);

    const onCloseRef = useRef<any>(null);
    const [hasOnClose, setHasOnClose] = useState(false);

    const handleSetOnClose = useCallback((callback: any) => {
        onCloseRef.current = callback;
        const hasCallback = !!callback;
        setHasOnClose((prev) => (prev !== hasCallback ? hasCallback : prev));
    }, []);

    useEffect(() => {
        setItems(presets.filter((item) => item.presetType === type));
    }, [presets, type]);

    return (
        <>
            <div className={styles.header}>
                <h1 className={styles.headerTitle}>
                    {type === GraphTypes.Legal
                        ? 'Your stored legal structures reviews.'
                        : type === GraphTypes.Taxes
                          ? 'Your stored deal taxes reviews.'
                          : type === GraphTypes.Optimisation
                            ? 'Your stored structures.'
                            : type === GraphTypes.Evergreen
                              ? 'Evergreen structures reviews.'
                              : type === GraphTypes.MultiLayered
                                ? 'Multi-layered taxes and structures.'
                                : type === GraphTypes.Library
                                  ? 'Workflows'
                                  : type === GraphTypes.Storage
                                    ? searchParams.get('categoryId') === 'deleted'
                                        ? 'Your deleted structures (can be restored)'
                                        : 'Your stored structures.'
                                    : 'Your stored reviews.'}
                </h1>

                {hasOnClose && onCloseRef.current && (
                    <>
                        {searchParams.get('categoryId') === 'saved' ? (
                            <Button onClick={onCloseRef.current} size={'sm'} before={<Icon icon={Icons.return} />}>
                                Back to short view
                            </Button>
                        ) : (
                            <Button
                                onClick={onCloseRef.current}
                                size={'sm'}
                                color={'neutral'}
                                before={<Icon icon={Icons.chevronTop} />}
                            >
                                Collapse all
                            </Button>
                        )}
                    </>
                )}
            </div>
            <div
                className={`${styles.wrapper} ${styles.wrapperContent} ${
                    type === 'storage'
                        ? styles.wrapperBlock
                        : `${styles.wrapperFlex} ${items?.length ? styles.wrapperContent : styles.wrapperEmpty}`
                }`}
            >
                {type === 'storage' ? (
                    <StorageContent grouped={false} showDeleted={true} setOnClose={handleSetOnClose} />
                ) : items?.length ? (
                    <>
                        {items.map((p: PresetInterface, i) => (
                            <Preset
                                key={i}
                                data={p}
                                handleDelete={handleDeletePopup}
                                setShowDownload={setShowDownload}
                            />
                        ))}
                    </>
                ) : (
                    <p className={styles.placehodler}>No structures stored yet.</p>
                )}
            </div>
        </>
    );
};

export default OverviewCategoryItems;
